import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-security-privacy',
  templateUrl: './security-privacy.component.html',
  styleUrls: ['./security-privacy.component.scss'],
  standalone: false,
})
export class SecurityPrivacyComponent {
  protected dialogRef =
    inject<MatDialogRef<SecurityPrivacyComponent>>(MatDialogRef);
  isModal = inject<boolean>(MAT_DIALOG_DATA, { optional: true });
}
